import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import applicationStatusMessageColumns from "./applicationStatusMessageColumns";

type Props = {
  name: string;
  active: boolean;
  data?: any;
};

const query = gql`
  query AllApplicationStatusMessages(
    $active: Boolean
    $offset: Int
    $limit: Int
  ) {
    application_status_messages(
      active: $active
      offset: $offset
      limit: $limit
    ) {
      id
      activated_at
      deactivated_at
      admin_user_activate
      admin_user_deactivate
      status_message {
        category
        level
        message_body
      }
      application {
        application_name
      }
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ active, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      active,
      offset,
      limit,
    },
  }),
});

const checkActiveStatusMessages = (passedProps: Props): Boolean => {
  if (passedProps.data.application_status_messages) {
    if (passedProps.data.application_status_messages.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  return false;
};

export default withPagination(
  withData((props) => (
    <BOGraphQLLoader data={props.data}>
      {checkActiveStatusMessages(props) ? (
        <div
          style={{
            paddingTop: "20px",
            paddingBottom: "25px",
          }}
        >
          There are currently no active status messages.
        </div>
      ) : (
        <div> </div>
      )}
      <ConfigurableTable
        columnConfigs={applicationStatusMessageColumns}
        defaultColumns={[
          "Application",
          "Activated at",
          "Activated by",
          "Deactivated at",
          "Deactivated by",
          "Deactivated at",
          "Category",
          "Level",
          "Message body",
          "Deactivate",
        ]}
        rows={props.data.application_status_messages || []}
        pagination={props.pagination}
        name={"Application status messages"}
      />
    </BOGraphQLLoader>
  ))
);
